"use client"

import { Figma } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FigmaIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FigmaIcon = component(Icon)({ as: Figma })
